export const examHeaders = [
	{ id: 'examType', label: 'Tipo de estudios', width: '290px' },
	{ id: 'status', label: 'Estatus estudios', width: '290px' },
	{ id: 'externalOrder', label: 'Folios de estudios', width: '290px' },
	{ id: 'serviceRequests', label: 'Resultados recibidos', width: '170px' },
];

export const lectureHeaders = [
	{
		id: 'examType',
		label: 'Nombre de la plática',
		width: '70%',
	},
	{
		id: 'status',
		label: 'Estatus',
		width: '30%',
	},
];

export const workshopsHeaders = [
	{
		id: 'examType',
		label: 'Nombre del taller',
		width: '70%',
	},
	{
		id: 'status',
		label: 'Estatus',
		width: '30%',
	},
];

export const sectionsHeaders = [
	{
		id: 'examType',
		label: 'Nombre de la sección',
		width: '70%',
	},
	{
		id: 'status',
		label: 'Estatus',
		width: '30%',
	},
];
